import SignUpErrorModal from './SignUpErrorModal';

export default SignUpErrorModal;


// WEBPACK FOOTER //
// ./src/components/SignUpErrorModal/index.jsx